import { render, staticRenderFns } from "./my-service.vue?vue&type=template&id=2afb77a4&scoped=true&"
import script from "./my-service.vue?vue&type=script&lang=js&"
export * from "./my-service.vue?vue&type=script&lang=js&"
import style0 from "./my-service.vue?vue&type=style&index=0&id=2afb77a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb77a4",
  null
  
)

export default component.exports